export const companies = [
  {
    date: "2021 May",
    content: {
      text: "Software Engineer at ",
      linkText: "Eyepax (PVT)Ltd.",
      linkHref: "https://eyepax.com",
    },
    duration: "(2021 May ~ Present)",
    skills: ['PHP'],
  },
  {
    date: "2020 October",
    content: {
      text: "Technical Lead at ",
      linkText: "Prologics IT Solutions",
      linkHref: "http://www.prologics.lk/",
    },
    duration: "(2020 October ~ Present)",
    skills: [],
  },
  {
    date: "2018 March",
    content: {
      text: "Software Engineer at ",
      linkText: "Saberion (PVT)Ltd.",
      linkHref: "https://saberion.com",
    },
    duration: "(2018 March ~ 2021 March)",
    skills: [],
  },
  {
    date: "2017 August",
    content: {
      text: "Software Engineer at ",
      linkText: "Asia media global (PVT)Ltd.",
      linkHref: "#",
    },
    duration: "(2017 August ~ 2018 February)",
    skills: [],
  },
  {
    date: "2016 March",
    content: {
      text: "Software Engineer at ",
      linkText: "LI Studios (PVT)Ltd.",
      linkHref: "https://www.listudiosl.com",
    },
    duration: "(2016 March ~ 2016 December)",
    skills: [],
  },
  {
    date: "2015 June",
    content: {
      text: "Associate Software Developer at ",
      linkText: "Multi Creative Solutions (PVT)Ltd.",
      linkHref: "https://mcreatives.com",
    },
    duration: "(2015 June ~ 2016 March)",
    skills: [],
  },
];
